// extracted by mini-css-extract-plugin
export default {"steparea":"Process_steparea__w91Lz","stepItem":"Process_stepItem__fOWN4","number":"Process_number__iJafI","stepContent":"Process_stepContent__5yvzy"};